import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReturnIcon from "../../../assets/icons/back_page.svg";
import { TextsProps } from "../../../database/txt.interface";
import { CartaoProps, FaturaProps } from "../../../interfaces/cartao.interface";
import { AppActions } from "../../../store/ducks/app";
import { FinancialActions } from "../../../store/ducks/financial";
import {
	Content,
	ContainerInfoCard,
	CardNumbers,
	ContainerIconEdit,
	Faturas,
	FaturasPendentes,
	ContainerTextFaturas,
	ArrowFaturas,
	Content2,
} from "./styles";
import history from "../../../routes/history";
import { ReactComponent as Edit } from "../../../assets/kinologyIcons/svg/edit.svg";
import { ReactComponent as Card } from "../../../assets/kinologyIcons/svg/credit_card.svg";
import { ReactComponent as Warning } from "../../../assets/kinologyIcons/svg/warningInvoices.svg";
import Invoice from "../../../assets/kinologyIcons/svg/Invoice.svg";
import ArrowInvoice from "../../../assets/kinologyIcons/svg/arrow_forward_ios.svg";
import Add from "../../../assets/kinologyIcons/svg/add_Payment_round.svg";
import Edit2 from "../../../assets/kinologyIcons/svg/edit.svg";
import { Colors } from "../../../styles/colors";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import { ContainerDash, Icon, Return } from "../../../styles/global";
import { H2Desk, P1Desk, P2Desk, P3Desk } from "../../../styles/styles_text";
import ModalFalhaPagamento from "./ModalFalhaPagamento";
import ModalBoleto from "./ModalBoleto";
import InvoiceComponent from "./ListaFaturas";
import styled from "styled-components";
import { ActivityIndicator } from "../../../components/Buttons/FormSubmitButton/style";

enum TypeFatura {
	BOLETO = "Boleto",
	PENDING = "pending",
}

const Pagamentos: React.FC = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const type_client: 'bank_slip_pix' | 'card' | null = useSelector((state: any) => state.financial.type_client);
	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);
	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;
	useEffect(() => {
		dispatch(
			FinancialActions.financial_request(
				config_servicos?.SERVICO_IUGU,
				config_servicos?.SERVICO_SUPERLOGICA
			)
		);
	}, []);
	const faturas = useSelector((state: any) => state.financial.faturas);
	const cartao = useSelector((state: any) => state.financial.cartao);

	const fatura = faturas?.filter(
		(fatura: FaturaProps) =>
			fatura?.FATURA_TIPO === TypeFatura?.BOLETO ||
			fatura?.FATURA_TIPO === TypeFatura?.PENDING
	);

	const handleVisualizarFatura = () => {
		dispatch(AppActions.set_open_visualizar_fatura(true));
	};
	const handleEditarMetodoPagamento = () => {
		dispatch(AppActions.set_editar_cartao(true));
		dispatch(DashBoardActions.set_current_page("adicionar_pagamento"));
	};


	useEffect(() => {
		dispatch(AppActions.set_open_barraSuperior("pagamentos"));
		
	}, []);

	return (
		<ContainerDash>
			<Content2>
				<Return
					onClick={() => {
						if(inadimplencia_motivo){
							dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo))
						}else{
							dispatch(DashBoardActions.set_current_page("minha_conta"));
							dispatch(
								AppActions.set_option_menu(
									false,
									current_language?.menu_lateral_minha_conta
								)
							);
						}
					}}
				>
					<Icon
						src={ReturnIcon}
						style={{ width: "0.875rem", height: "0.875rem" }}
					/>
					<P3Desk style={{ color: Colors?.primary_blue_k_main }}>
						{current_language?.menu_lateral_minha_conta}
					</P3Desk>
				</Return>
				<H2Desk style={{ marginTop: "1rem", fontSize: "1.5rem" }}>
					{current_language?.pagamentos}
				</H2Desk>
				<P2Desk style={{ marginTop: "1rem", fontSize: "1rem" }}>
					{current_language?.metodo_pagamento}
				</P2Desk>
				<Content>
					<ModalBoleto />
					{cartao?.length > 0 && type_client === 'card' ? (
						cartao?.map((card: CartaoProps) => (
							<ContainerInfoCard key={card.CC_NUMERO} >
								<CardNumbers onClick={()=> dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo)) }>
									{
										card.CC_ERRO 
										? <Warning  color={Colors.tertirary_red_2_dark} 
												width={20} height={32}
												style={{marginRight:5}}
											/>
										: <Card color={Colors?.primary_blue_k_main} />
									}
									
									<P2Desk
										style={
											card?.CC_ERRO ? { color: "#A81F00" } : { color: "" }

										}
									>
										****-****-****- 
										{cartao?.[0]?.CC_NUMERO.split('*')?.[cartao[0].CC_NUMERO.split('*').length -1]}
									</P2Desk>
								</CardNumbers>
								<ContainerIconEdit
									onClick={() => {handleEditarMetodoPagamento()	}}
								>
									<Edit
										color={Colors.primary_blue_k_main}
										className="EditCard"
										style={{ height: "1rem" }}
									/>
								</ContainerIconEdit>
								{card.CC_ERRO && (
									<P2Desk style={{cursor: 'pointer', marginLeft: "1.6rem", color: "#A81F00" }} onClick={()=> dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo)) }>
										{current_language?.problemas_cartao}
									</P2Desk>
								)}
							</ContainerInfoCard>
						))
					) : (
						<Container className="boleto">
							<IconContainer>!</IconContainer>
							<Content3>
								<Title>{current_language?.boleto}</Title>
								<Description>{current_language?.trocar_pagamento_cartao}</Description>
							</Content3>
							<EditIcon>
								{
									<img
										style={{ height: "1rem", position: 'absolute', top:10, right:10}}
										src={Edit2}
										onClick={() => {
											dispatch(
												DashBoardActions.set_current_page("adicionar_pagamento")
											);
											dispatch(AppActions.set_editar_cartao(true))
										}}
									/>
								}
							</EditIcon>
						</Container>
					)}
				</Content>
				{
					faturas?.length > 0 
					? <InvoiceComponent />
					:	<div style={{display: "flex",height: 300,  alignItems: 'center', justifyContent: 'center'}}>
						 <ActivityIndicator  style={{height: 18, width: 18}}  />
						</div>
				}
				

			</Content2>
		</ContainerDash>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	border-radius: 8px;
	margin-bottom: 16px;
	margin-top: 1rem;
`;

const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.2rem;
	height: 1.2rem;
	background-color: #ffdd99;
	border-radius: 50%;
	color: #cc8400;
	margin-right: 12px;
	font-size: 12px;
`;

const Content3 = styled.div`
	flex: 1;
`;

const Title = styled.h3`
	margin: 0;
	font-size: 16px;
	color: #002060;
	font-weight: bold;
`;

const Description = styled.p`
	margin: 4px 0 0;
	width: 80%;
	font-size: 14px;
	color: #7d7d7d;
`;

const EditIcon = styled.div`
	margin-left: auto;
	color: #002060;
	cursor: pointer;

	&:hover {
		color: #0056b3;
	}
`;

export default Pagamentos;
